import React from "react";

export const NavyBlueAlert = (props) => {
  return (
    <div className="fgaAlert navyBlueAlert">
      <div className="alertIcon">
        <span className="icon-icon-menu-faq"></span>
      </div>
      <div className="alertText">{props.content}</div>
    </div>
  );
};

// export default NavyBlueAlert;
